import React, { useEffect, useState } from 'react';
import { Grid2, Card, CardContent, CardActions, Button, Typography, CardMedia, Chip, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const cardStyle = {
    width: 300,
    height: 460,
    display: 'flex',
    flexDirection: 'column',
    background: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(4px)',
    border: '2px solid rgba(120, 53, 15, 0.6)',
    borderRadius: '10px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.4)',
    transition: 'transform 0.15s ease, border-color 0.15s ease',
    '&:hover': {
        transform: 'translateY(-4px)',
        borderColor: '#f59e0b',
    }
};

const chipStyle = {
    backgroundColor: 'rgba(120, 53, 15, 0.4)',
    color: '#ffffff',
    border: '1px solid rgba(245, 158, 11, 0.5)'
};

function BuisnessGrid() {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);

                const response = await fetch(`${import.meta.env.VITE_REACT_API_URL}/api/listings/businesses`);
                if (!response.ok) {
                    throw new Error("Failed to fetch data");
                }
                const result = await response.json();
                setData(result);

            } catch (err) {
                setError(err.message);
                console.error("Error fetching data:", err);
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, []);

    const parseJsonArray = (raw) => {
        try {
            return JSON.parse(raw) || [];
        } catch {
            return [];
        }
    };

    const handleButtonClick = (id) => {
        navigate(`/buisnessinfo/${id}`);
    };

    if (error) {
        return <Typography>Error: {error}</Typography>;
    }

    return (
        <Grid2 container spacing={3} justifyContent="center" alignItems="stretch" sx={{ marginTop: 4 }}>
            {data.map((item) => {
                const images = parseJsonArray(item.images);
                const tags = parseJsonArray(item.tags);

                return (
                    <Grid2 item xs={12} sm={6} md={4} lg={3} key={item.id}>
                        <Card sx={cardStyle}>
                            <CardMedia
                                component="img"
                                height="160"
                                image={images[0] || '/map.png'}
                                alt={item.title}
                            />
                            <CardContent sx={{ flexGrow: 1 }}>
                                <Typography gutterBottom variant="h5" component="div" sx={{ color: '#ffffff', fontFamily: 'Playfair Display, serif' }}>
                                    {item.title}
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'rgba(254, 243, 199, 0.8)' }}>
                                    {item.location}{item.region ? ` — ${item.region}` : ''}
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'rgba(254, 243, 199, 0.8)' }}>
                                    Business {item.property_number}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#f59e0b', fontWeight: 600, mt: 0.5 }}>
                                    Current Bid: ${item.current_bid}
                                </Typography>
                                <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{ mt: 1 }}>
                                    {tags.map((tag, index) => (
                                        <Chip key={index} label={tag} size="small" sx={chipStyle} />
                                    ))}
                                </Stack>
                            </CardContent>
                            <CardActions sx={{ justifyContent: 'center', pb: 2 }}>
                                <Button
                                    size="small"
                                    onClick={() => handleButtonClick(item.id)}
                                    sx={{
                                        backgroundColor: '#1976d2',
                                        color: 'white',
                                        '&:hover': {
                                            backgroundColor: '#115293',
                                        },
                                        borderRadius: '8px',
                                        padding: '9px 16px',
                                        fontSize: '14px',
                                    }}
                                >
                                    View Business
                                </Button>
                            </CardActions>
                        </Card>
                    </Grid2>
                );
            })}
        </Grid2>
    );
}

export default BuisnessGrid;
